import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import EmptyState from './EmptyState';

const emptyStateConfig = {
  image: getImage('noUpcomingBatches.svg'),
  title: 'No batches found',
  description: 'Upcoming batches will show up here'
};

const emptyBatchStateConfigOnEducator = {
  image: getImage('noUpcomingBatches.svg'),
  title: 'No batches and trial classes',
  description:
    'This educator doesn’t have any batch and trial classes right now'
};

export const emptyUpcomingStateConfig = {
  image: getImage('noUpcomingBatches.svg'),
  title: 'No upcoming batches',
  description: 'Upcoming batches will show up here'
};

const EmptyStateContainer = styled.div`
  grid-column-gap: ${Spacings.SPACING_4B};
  grid-template-columns: repeat(18, 32px);
  grid-column: 1/19;
  height: 384px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  h3 {
    font-size: ${Fonts.LARGE};
  }
  p {
    font-size: ${Fonts.P2};
    color: var(--color-text-secondary);
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 290px;
    img {
      height: 90px;
      width: 90px;
    }
    h3 {
      margin-top: ${Spacings.SPACING_4B};
      margin-bottom: ${Spacings.SPACING_2B};
    }
  }
`;
const EmptyStateWrapper = styled(EmptyState)`
  margin: auto ${Spacings.SPACING_0B};
  width: 265px;
`;

const EmptyBatchStateWrapper = styled.div`
  margin-top: ${Spacings.SPACING_10B};
  margin-bottom: ${Spacings.SPACING_18B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
    margin-right: ${Spacings.SPACING_0B};
  }
`;

export const Container = styled(EmptyStateContainer)`
  border-radius: ${Spacings.SPACING_1B};
`;

const BatchGroupEmptyState = ({ config = emptyStateConfig }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateWrapper
        imgSrc={config.image}
        title={config.title}
        description={config.description}
      />
    </EmptyStateContainer>
  );
};

export default BatchGroupEmptyState;

export const BatchesEmptyState = ({
  config = emptyBatchStateConfigOnEducator
}) => {
  return (
    <EmptyBatchStateWrapper>
      <BatchGroupEmptyState config={config} />
    </EmptyBatchStateWrapper>
  );
};

export const UpcomingBatchEmptyState = ({ config = emptyStateConfig }) => {
  return (
    <Container>
      <EmptyStateWrapper
        imgSrc={config.image}
        title={config.title}
        description={config.description}
      />
    </Container>
  );
};
